import { h } from 'preact'
import Icon from '../assets'

const TopicPreviewNotice = ({ isPreviewPublic }: { isPreviewPublic: boolean }) => {
  const noticeText = isPreviewPublic
    ? 'Anyone who has the link can access preview via the link without signing in'
    : 'Only people with moderator role or above can access this page via the link'

  return (
    <div className='box'>
      <div className='topic-preview__notice'>
        <div className='topic-preview__notice-label h3'>Preview</div>
        <div className='topic-preview__notice-desc'>
          <div className='topic-preview__notice-icon'>
            <Icon icon='people' height={16} width={15} color='#6B707E' />
          </div>
          <div className='topic-preview__notice-text'>{ noticeText }</div>
        </div>
      </div>
    </div>
  )
}

export default TopicPreviewNotice
